import { render } from "./ProductsReport.vue?vue&type=template&id=231d7368&scoped=true"
import script from "./ProductsReport.vue?vue&type=script&lang=js"
export * from "./ProductsReport.vue?vue&type=script&lang=js"

import "./ProductsReport.vue?vue&type=style&index=0&id=231d7368&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-231d7368"]])

export default __exports__